/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EDocSignerRole, EDocSigningStatus } from '@gh/builder-shared-data';
import { createDialogRoute, EnumDictionary, FormState, FormStateBuilder, getDialogInitData } from '@gh/common-shared';
import { DialogInput } from '@gh/core-ui';
import { communicationAttachmentToFile } from '../../../communications';
import { EDocDetailsBusinessService, EDocDetailsDialogConfig } from '../../resources/e-doc-details-business.service';
import {
  EDoc,
  EDocDetails,
  getEDocSignerEmailByRole,
  getEDocSignerNameByRole,
  getEDocSignerStatusByRole,
} from '../../resources/e-doc-details.model';

@Component({
  selector: 'gh-e-doc-details-dialog',
  template: require('./e-doc-details-dialog.component.html'),
})
export class EDocDetailsDialogComponent implements OnInit, DialogInput<EDocDetailsDialogConfig> {
  input: EDocDetailsDialogConfig;

  form: FormState<EDocDetails>;

  documentType: string;
  officeStatus?: EDocSigningStatus;
  owner1Status?: EDocSigningStatus;
  owner2Status?: EDocSigningStatus;
  owner3Status?: EDocSigningStatus;

  private document: EDoc;
  private signingStatusDict: EnumDictionary<EDocSigningStatus>;

  constructor(@Inject(MAT_DIALOG_DATA) private dialogData: any,
              private dialogRef: MatDialogRef<any>,
              private formStateBuilder: FormStateBuilder) {
  }

  ngOnInit(): void {
    const { document, edocTypeDict, signingStatusDict } = getDialogInitData(this.dialogData);

    this.document = document;
    this.signingStatusDict = signingStatusDict;

    this.form = this.formStateBuilder.buildPlain({
      enabled: false,
      value: {
        owner1: getEDocSignerNameByRole(document, EDocSignerRole.Owner1),
        owner2: getEDocSignerNameByRole(document, EDocSignerRole.Owner2),
        owner3: getEDocSignerNameByRole(document, EDocSignerRole.Owner3),
        email1: getEDocSignerEmailByRole(document, EDocSignerRole.Owner1),
        email2: getEDocSignerEmailByRole(document, EDocSignerRole.Owner2),
        email3: getEDocSignerEmailByRole(document, EDocSignerRole.Owner3),
        files: document.files.map(communicationAttachmentToFile),
      },
      children: {
        owner1: void 0,
        owner2: void 0,
        owner3: void 0,
        email1: void 0,
        email2: void 0,
        email3: void 0,
        files: void 0,
      },
    });

    this.documentType = edocTypeDict.get(document.docType);
    this.officeStatus = getEDocSignerStatusByRole(document, EDocSignerRole.Office);
    this.owner1Status = getEDocSignerStatusByRole(document, EDocSignerRole.Owner1);
    this.owner2Status = getEDocSignerStatusByRole(document, EDocSignerRole.Owner2);
    this.owner3Status = getEDocSignerStatusByRole(document, EDocSignerRole.Owner3);
  }

  onClose(): void {
    this.dialogRef.close();
  }

  getStatusText(status?: EDocSigningStatus): string {
    return status ? this.signingStatusDict.get(status) : '\u2014';
  }

}

export const edocDetailsDialogRoute = createDialogRoute({
  component: EDocDetailsDialogComponent,
  init: EDocDetailsBusinessService,
});
